import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthorizationService } from './services/authorization.service';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthorizationService
  ) {}

  canActivate(): boolean {

    const token = sessionStorage.getItem('momaccesstoken');

    console.log('LoginRedirectGuard - Ping Enabled:', environment.isPingEnable);

    // ✅ Already logged in → go to dashboard
    if (token) {
      this.router.navigate(['/dashboard']);
      return false;
    }

    // ✅ Ping enabled → call authorize directly, no flicker
    if (environment.isPingEnable) {
      this.authService.authorize(); // redirects to Ping federation
    } 
    // ✅ Ping disabled → redirect to manual login
    else {
      this.router.navigate(['/extlogin']);
    }

    return false; // always block Logintype component
  }
}